/* <x-tabs>: WAI-ARIA tabs with roving tabindex. Arrow keys follow reading direction (RTL aware). */
if (!customElements.get('x-tabs')) {
  customElements.define(
    'x-tabs',
    class XTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll(':scope [role="tab"]')].filter((tab) => tab.closest('x-tabs') === this);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      select(tab, focus = false) {
        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        this.dispatchEvent(new CustomEvent('tabs:change', { detail: { tab }, bubbles: true }));
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        const rtl = getComputedStyle(this).direction === 'rtl';
        const next = rtl ? 'ArrowLeft' : 'ArrowRight';
        const prev = rtl ? 'ArrowRight' : 'ArrowLeft';
        let target;
        if (event.key === next) target = this.tabs[(index + 1) % this.tabs.length];
        else if (event.key === prev) target = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        else if (event.key === 'Home') target = this.tabs[0];
        else if (event.key === 'End') target = this.tabs[this.tabs.length - 1];
        if (!target) return;
        event.preventDefault();
        this.select(target, true);
      }
    }
  );
}
